import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

import "./_EventPayrollPaymentSummary.scss";

const EventPayrollPaymentSummary = ({ paidCount, pendingCount, labels }) => (
  <Box className="event-payroll__payment-summary">
    <Box className="event-payroll__payment-summary-item event-payroll__payment-summary-item--paid">
      <span className="event-payroll__payment-summary-number">
        {paidCount}
      </span>
      <span className="event-payroll__payment-summary-label">
        {labels.paidPayment}
      </span>
    </Box>
    <span className="event-payroll__payment-summary-divider" aria-hidden />
    <Box className="event-payroll__payment-summary-item event-payroll__payment-summary-item--pending">
      <span className="event-payroll__payment-summary-number">
        {pendingCount}
      </span>
      <span className="event-payroll__payment-summary-label">
        {labels.pendingPayment}
      </span>
    </Box>
  </Box>
);

EventPayrollPaymentSummary.propTypes = {
  paidCount: PropTypes.number.isRequired,
  pendingCount: PropTypes.number.isRequired,
  labels: PropTypes.shape({
    paidPayment: PropTypes.string.isRequired,
    pendingPayment: PropTypes.string.isRequired,
  }).isRequired,
};

export default EventPayrollPaymentSummary;
